import axios from 'axios'

// Uploads the given file through the backend (POST /v2/upload/file), which
// proxies it to S3 server-side. Previously this uploaded directly from the
// browser to S3 using AWS credentials hardcoded in this very file - a real,
// critical vulnerability, since anyone could extract those credentials from
// the shipped frontend JS bundle. The exposed key has been removed from
// source; it must also be deactivated/rotated in AWS IAM directly (this
// code change alone does not revoke an already-leaked key).
//
// Every existing call site (`await Upload(file)`) keeps working unchanged -
// same signature, same return value (a URL string, or null on failure).
const Upload = async file => {
    const formData = new FormData();
    formData.append('file', file);

    return axios
        .post('/v2/upload/file', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        })
        .then(({ data }) => data && data.location ? data.location : null)
        .catch(() => null);
};

export default Upload;
